import classNames from 'classnames'
import { usePartnerId } from 'legacy/lut/classes/helpers/partner360/usePartnerId'
import { Dropdown } from 'legacy/lut/library/dropdown'
import React, { useEffect } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Loader } from 'core-components/library/loader'
import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

import { crudInfo, fyearHistoryMap } from './configs'
import { useFYearsCrud } from './hooks/useFYearsCrud'

import styles from './FYearsSelector.module.scss'

interface IFYearSelectorProps {
  pid: string
  widgetParams: IObjectAny
  className?: string
}

export const FYearSelector = (props: IFYearSelectorProps) => {
  const partnerId = usePartnerId(props.widgetParams, props.pid)
  const { currentFYear, setCurrentFYear, fYearsCrud, isLoaded } = useFYearsCrud(partnerId)

  useEffect(() => {
    if (partnerId && currentFYear) {
      fyearHistoryMap.set(partnerId, currentFYear.toString())
    }

    crudInfo.forEach((el) => {
      const crud = CrudStore.get(el.id, el.key)
      crud.setDefaultFilter({
        logic: Logic.AND,
        filters: [
          {
            field: 'FYear',
            operator: Operator.EQUAL,
            value: currentFYear,
          },
        ],
      })
      el.id === 'CompensationScheme' && crud.triggerOnChange()
    })
  }, [partnerId, currentFYear])

  if (!isLoaded) {
    return <Loader />
  }

  return (
    <div className={classNames(styles.root, props.className || '')}>
      <p className={styles.label}>
        <Translation text="jbp-fyears-dropdown" actionsInside span />
      </p>
      <div className={styles.dropdownWrapper} data-testid="fYearSelector-dropdown-wrapper">
        <Dropdown
          source={fYearsCrud}
          caption="fYear"
          value={currentFYear}
          onChange={setCurrentFYear}
          classes={{
            inputClasses: {
              root: styles.dropdownInput,
            },
          }}
        />
      </div>
    </div>
  )
}

export default FYearSelector
